import Vector from '../../imports/Vector';
import Layer1 from '../../imports/Layer1';
import { useLanguage } from '@/contexts/AppContext';
import { profileTranslations } from './profileTranslations';

interface ProfileHeaderProps {
  profileImage: string | null;
  onBackClick: () => void;
  onImageClick: () => void;
}

export function ProfileHeader({
  profileImage,
  onBackClick,
  onImageClick,
}: ProfileHeaderProps) {
  const { language, locale } = useLanguage();
  const t = profileTranslations[locale];

  return (
    <>
      {/* Header */}
      <div className="bg-primary">
        <div className="flex items-center justify-between h-[50px] px-5">
          <button
            onClick={onBackClick}
            className="flex items-center justify-center w-8 h-8"
          >
            <div className="w-3 h-[21px]">
              <Vector />
            </div>
          </button>
          <h1 className={`text-white font-bold text-base tracking-[-0.32px] text-center ${language !== 'ko' ? 'uppercase' : ''}`}>
            {t.title}
          </h1>
          <div className="w-8" />
        </div>
      </div>

      {/* Profile Avatar */}
      <div className="flex justify-center mb-[min(8vw,2.5rem)]">
        <div className="relative">
          <button
            onClick={onImageClick}
            className="group relative w-[min(19.6vw,4.9rem)] h-[min(19.6vw,4.9rem)] rounded-full overflow-hidden bg-muted flex items-center justify-center border-[1.5px] border-primary/20 shadow-sm hover:shadow-md hover:scale-105 active:scale-95 transition-all duration-300 hover:border-primary/40"
          >
            {profileImage ? (
              <img
                src={profileImage}
                alt="Profile"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              />
            ) : (
              <div className="w-[min(9.8vw,2.45rem)] h-[min(9.8vw,2.45rem)] group-hover:scale-110 transition-transform duration-300">
                <Layer1 />
              </div>
            )}
          </button>
        </div>
      </div>
    </>
  );
}
